module.exports = __webpack_public_path__ + "assets/img/bbab-cx.svg";